export const CHECKOUT_CURRENCY = "USD";

export const CHECKOUT_PACKAGES = [
  { id: "load-25", valueCents: 2500, priceCents: 2300 },
  { id: "load-50", valueCents: 5000, priceCents: 4600 },
  { id: "load-100", valueCents: 10000, priceCents: 9000 },
  { id: "load-150", valueCents: 15000, priceCents: 13500 },
  { id: "load-200", valueCents: 20000, priceCents: 17000 },
  { id: "load-250", valueCents: 25000, priceCents: 21250 },
  { id: "load-300", valueCents: 30000, priceCents: 24600 },
  { id: "load-350", valueCents: 35000, priceCents: 28700 },
] as const;

export const CHECKOUT_LOCATIONS = [
  { id: "waukee", code: "WAK", name: "Waukee Auto Wash", city: "Waukee" },
  { id: "grimes", code: "GRM", name: "Grimes Laser Wash", city: "Grimes" },
  { id: "adel", code: "ADL", name: "Clean Works Adel", city: "Adel" },
  { id: "urbandale", code: "URB", name: "Clean Works on 156th", city: "Urbandale" },
] as const;

export type CheckoutPackage = (typeof CHECKOUT_PACKAGES)[number];
export type CheckoutLocation = (typeof CHECKOUT_LOCATIONS)[number];
export type CheckoutFlow = "activation" | "reload";

export function formatMoney(cents: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: CHECKOUT_CURRENCY,
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
  }).format(cents / 100);
}

export function savingsPercent(item: CheckoutPackage): number {
  return Math.round(((item.valueCents - item.priceCents) / item.valueCents) * 100);
}
